import { render } from "./AlmostTherePage.vue?vue&type=template&id=7f020f26&scoped=true"
import script from "./AlmostTherePage.vue?vue&type=script&lang=js"
export * from "./AlmostTherePage.vue?vue&type=script&lang=js"

import "./AlmostTherePage.vue?vue&type=style&index=0&id=7f020f26&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f020f26"]])

export default __exports__